import React from 'react';
import { withStyles } from 'material-ui/styles';
import UISwitch from '../../core/ui/switch.js';
import UIFormControlLabel from '../../core/ui/form_control_label.js';

const styles = [];

class DevMode extends React.Component {
  constructor() {
    super();

    this.state = {
      checked: false,
    };    

    this.onChange = this.onChange.bind(this);
  }
  
  onChange(value) {
    const $this = this;
    this.setState({checked: value}, function(){
      if($this.props.onChange){
        $this.props.onChange(this.state.checked)
      }    
    });
  };

  render() {
    const label = (this.props.checked) ? "Debug Mode ON" : "Debug Mode OFF";
    return (
      <UIFormControlLabel 
        control={<UISwitch checked={this.props.checked} onChange={this.onChange}/>} 
        label={label}
      />
    );
  }
}

export default withStyles(styles)(DevMode);


// WEBPACK FOOTER //
// ./src/search/ui/search_ui_devmode.js